/* ================================================================
   WISHLIST CORE
================================================================ */

(function () {
  // Prevent double-initialization when sections reload
  if (window.__wishlistInitDone) return;
  window.__wishlistInitDone = true;

  function bootWishlist() {
    initializeWishlist();
    initializeWishlistButtonState();
  }

  // DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootWishlist);
  } else {
    bootWishlist();
  }

  // When Shopify reloads sections (Dawn + Theme Editor)
  document.addEventListener("shopify:section:load", function () {
    // Refresh heart state + counters + drawer *after* section HTML exists
    initializeWishlistButtonState();
    updateWishlistCounter();
    updateWishlistDrawer();   // 🔥 this is the important addition
  });

  // Header / icon trigger: ensure we always refresh drawer BEFORE open
  document.addEventListener("click", function (e) {
    const trigger = e.target.closest("[open-wishlist]");
    if (!trigger) return;

    e.preventDefault();
    updateWishlistDrawer(); // refresh from localStorage each time
    if (typeof openWishlistDrawer === "function") {
      openWishlistDrawer();
    }
  });
})();

/* ================================================================
   INITIALIZERS
================================================================ */

function initializeWishlist() {
  // Body delegation for heart buttons
  document.body.addEventListener("click", handleWishlistButtonClick);

  // Wishlist ATC
  document.body.addEventListener("click", handleWishlistATCClick);

  // Initial paint (will gracefully no-op if drawer not yet in DOM)
  updateWishlistDrawer();
  updateWishlistCounter();
}

function initializeWishlistButtonState() {
  const wishlistButtons = document.querySelectorAll("[button-wishlist]");
  const wishlist = WishlistManager.getWishlist();

  wishlistButtons.forEach((button) => {
    const handle = button.dataset.productHandle;
    button.classList.toggle("active", wishlist.includes(handle));
  });
}

/* ================================================================
   LOCALSTORAGE MANAGER
================================================================ */

const WishlistManager = {
  key: "shopify-wishlist",
  delimiter: ",",

  getWishlist() {
    const wishlist = localStorage.getItem(this.key);
    return wishlist ? wishlist.split(this.delimiter) : [];
  },

  saveWishlist(list) {
    if (list.length) localStorage.setItem(this.key, list.join(this.delimiter));
    else localStorage.removeItem(this.key);
  },

  add(handle) {
    const list = this.getWishlist();
    if (!list.includes(handle)) {
      list.push(handle);
      this.saveWishlist(list);
    }
  },

  remove(handle) {
    const list = this.getWishlist().filter((h) => h !== handle);
    this.saveWishlist(list);
  },

  contains(handle) {
    return this.getWishlist().includes(handle);
  }
};

/* ================================================================
   HEART BUTTON TOGGLE
================================================================ */

function handleWishlistButtonClick(e) {
  const button = e.target.closest("[button-wishlist]");
  if (!button) return;

  e.preventDefault();
  const handle = button.dataset.productHandle;
  if (!handle) return;

  if (WishlistManager.contains(handle)) {
    WishlistManager.remove(handle);
    button.classList.remove("active");
  } else {
    WishlistManager.add(handle);
    button.classList.add("active");
  }

  updateWishlistDrawer();
  updateWishlistCounter();

  if (typeof openWishlistDrawer === "function") {
    openWishlistDrawer();
  }
}

/* ================================================================
   UNIVERSAL WISHLIST ADD-TO-CART HANDLER
================================================================ */

function handleWishlistATCClick(e) {
  const btn = e.target.closest("[wishlist-atc]");
  if (!btn) return;

  e.preventDefault();

  const handle =
    btn.dataset.productHandle ||
    btn.closest("[data-product-handle]")?.dataset.productHandle;

  const variantId =
    btn.dataset.variantId ||
    btn.getAttribute("onclick")?.match(/\((\d+)\)/)?.[1];

  if (!variantId) {
    console.error("[wishlist-atc] Missing variantId");
    return;
  }

  const id = Number(variantId);

  const afterAdd = () => {
    if (handle) {
      WishlistManager.remove(handle);
    }
    updateWishlistDrawer();
    updateWishlistCounter();

    // remove active heart globally
    if (handle) {
      document
        .querySelectorAll(
          '[button-wishlist][data-product-handle="' + handle + '"]'
        )
        .forEach((h) => h.classList.remove("active"));
    }
  };

  // 1️⃣ Use theme's Shopify.addItem if available
  if (window.Shopify && typeof Shopify.addItem === "function") {
    Shopify.addItem(id, 1, function (cart) {
      if (typeof Shopify.onCartUpdate === "function") {
        Shopify.onCartUpdate(cart);
      }
      afterAdd();
    });
    return;
  }

  // 2️⃣ Fallback AJAX
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: [{ id, quantity: 1 }] })
  })
    .then((r) => r.json())
    .then((cart) => {
      console.log("[wishlist-atc] Added to cart", cart);
      afterAdd();
    })
    .catch((err) => console.error("[wishlist-atc] Failed", err));
}

/* ================================================================
   WISHLIST DRAWER RENDER
================================================================ */
function updateWishlistDrawer() {
  const wishlist = WishlistManager.getWishlist();
  const grid = document.querySelector("[grid-wishlist]");
  const checkoutEl = document.querySelector(".wishlist-checkout");

  if (!grid) return;

  if (!wishlist.length) {
    grid.innerHTML = '<h4>Your wishlist is empty.</h4>';
    if (checkoutEl) checkoutEl.style.display = "none";
    return;
  }

  if (checkoutEl) checkoutEl.style.display = "";

  // ✅ Section Rendering API: returns ONLY the HTML for our drawer section
  const handlesParam = encodeURIComponent(wishlist.join(","));
  const url = `/ ?sections=wishlist-drawer-render&handles=${handlesParam}`.replace("/ ?", "/?");

  fetch(url, { credentials: "same-origin" })
    .then((r) => r.json())
    .then((data) => {
      const html = data["wishlist-drawer-render"] || "";
      grid.innerHTML = html.trim() ? html : "<p>Unable to load wishlist items.</p>";
      initializeWishlistButtonState(); // re-bind active heart states
    })
    .catch((err) => {
      console.error("[WishlistDrawer] Render failed", err);
      grid.innerHTML = "<p>Unable to load wishlist items.</p>";
    });
}

window.updateWishlistDrawer = updateWishlistDrawer;


/* ================================================================
   UPDATE COUNTER
================================================================ */

function updateWishlistCounter() {
  const count = WishlistManager.getWishlist().length;
  document.querySelectorAll(".wishlistitems-count").forEach((el) => {
    el.textContent = count;
  });
}

window.updateWishlistCounter = updateWishlistCounter;

/* ================================================================
   CART → WISHLIST (MOVE)
================================================================ */

function moveToWishlist(button) {
  const handle = button.dataset.productHandle;
  const variantId = button.dataset.variantId;

  if (!handle || !variantId) return;

  WishlistManager.add(handle);

  updateWishlistDrawer();
  updateWishlistCounter();

  fetch(`/cart/change.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 0 })
  })
    .then((r) => r.json())
    .then((cart) => {
      if (window.Shopify && typeof Shopify.cartUpdateInfo === "function") {
        Shopify.cartUpdateInfo(cart, ".single-cart-item-loop");
      }
    })
    .catch((err) => console.error("[MoveToWishlist] Error", err));
}

/* ================================================================
   CHECKOUT SYNC
================================================================ */

async function syncWishlistToCart() {
  const handles = WishlistManager.getWishlist();
  if (!handles.length) return;

  const products = await Promise.all(
    handles.map((h) =>
      fetch(`/products/${h}.js`)
        .then((r) => r.json())
        .catch(() => null)
    )
  );

  const items = [];

  products.forEach((p) => {
    if (!p) return;
    const v = p.variants.find((v) => v.available) || p.variants[0];
    if (v?.id) items.push({ id: v.id, quantity: 1 });
  });

  if (!items.length) return;

  await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items })
  });
}

/* ================================================================
   CHECKOUT BUTTON LISTENER
================================================================ */

document.addEventListener("click", async function (e) {
  const checkoutBtn = e.target.closest(
    ".wishlist-checkout button, .wishlist-checkout a"
  );
  if (!checkoutBtn) return;

  e.preventDefault();

  if (checkoutBtn.dataset.syncing === "1") return;
  checkoutBtn.dataset.syncing = "1";
  checkoutBtn.disabled = true;

  try {
    await syncWishlistToCart();

    if (window.GoKwik?.checkout) GoKwik.checkout();
    else if (window.GoKwik?.open) GoKwik.open();
    else window.location.href = "/checkout";
  } catch (err) {
    console.error("[Wishlist→Cart] Sync error", err);
  }

  checkoutBtn.disabled = false;
  checkoutBtn.dataset.syncing = "0";
});
